import React from 'react';

const Responsive = (props) => {
    return (

        <div className='responsivePlaceholder'>

            <div className="slide1Filter__title responsiveLogo">

                <span className="slide1Filter__title__titleLogo">
                    <span className="letter1">F</span>
                    <span className="letter2">C</span>
                    <span className="letter3">U</span>
                </span>

                <div className="hero-container">
                    <div className="environment"></div>
                    <h2 className="hero glitch layers sousTitre" data-text="force coloniale unifiée"><span>force coloniale unifiée</span></h2>
                </div>
            </div>

            <span className='responsiveText'>
                <p>Version mobile en préparation.</p>
                <p>Rejoignez nous sur discord!</p>
            </span>

            <a href='https://discord.gg/fcu' target='blank'><div className="buttonEffect"></div><p>Nous rejoindre!</p></a>


        </div>
    );
};

export default Responsive;